import { Backdrop, Box, Button, CircularProgress, Fade, IconButton, Modal, Paper, Typography } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import React, { useEffect, useState } from 'react';
import { useThemes } from '../Theme/theme';
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  // bgcolor: "background.paper",
  boxShadow: 24,
  // p: 4,
  outline: 'none',
  minWidth: '600px',
};

const UserInactiveModal = ({ open, setOpen, logout, logedIn }) => {
  const { theme } = useThemes();

  const [timer, setTimer] = useState(60);

  useEffect(() => {
    let countDownTime;
    if (open) {
      countDownTime = setInterval(() => {
        setTimer((prev) => {
          if (prev <= 1) {
            clearInterval(countDownTime);
            logout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);
    }
    return () => clearInterval(countDownTime);
  }, [open, logout]);

  const modalClose = (event, reason) => {
    if (reason !== 'backdropClick') {
      setOpen(false);
    }
  };
  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
      }}
      onClose={modalClose}
    >
      <Fade in={open}>
        <Paper sx={style}>
          <Box
            sx={{
              backgroundColor: 'primary.main',
              padding: '5px 15px',
              display: 'flex',
              flexDirection: 'row',
            }}
          >
            <Box sx={{ flex: 1 }}>
              <Typography
                sx={{
                  color: '#fff',
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                Alert
                {/* <IconButton aria-label="delete" onClick={modalClose}>
                                    <CloseIcon sx={{ color: "#fff" }} />
                                </IconButton> */}
              </Typography>
            </Box>
          </Box>

          <Box
            sx={{
              padding: '15px',
              // height:{xs:"400px",sm:'auto'},
            }}
          >
            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: 700,
                color: theme?.palette?.TmId.id.toString().includes('9') ? '#FFF1E6' : '#00000099',
              }}
            >
              You have been Idle for a while
            </Typography>
            <Typography sx={{ fontSize: '14px', fontWeight: 600, color: 'input.font', display: 'flex' }}>
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <p>You'll be logged out in&nbsp;</p>
                <p style={{ color: 'red', margin: 0 }}>{timer < 10 ? `0${timer}` : timer}</p>
                <p>&nbsp;seconds...</p>
              </div>
            </Typography>
          </Box>

          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: { xs: 'column', sm: 'row' },
            }}
          >
            <Button onClick={logedIn} variant="outlined" sx={{ flex: 1, margin: '10px', fontSize: '12px', display: 'flex', gap: '20px' }}>
              <Box>Keep me signed in</Box>
              {/* <Box sx={{width: "50px",textTransform:"lowercase"}}>{timer}sec</Box> */}
              {/* <CircularProgress variant="determinate" value={(timer/TOTAL_TIME)*100} size={15}  thickness={5}/> */}
            </Button>
            {/* {open && ( */}
            <Button
              onClick={() => {
                logout();
              }}
              variant="contained"
              sx={{ flex: 1, margin: '10px', fontSize: '12px' }}
            >
              Log me Out
            </Button>
            {/* )} */}
          </Box>
        </Paper>
      </Fade>
    </Modal>
  );
};
export default UserInactiveModal;
